const borrowInvoiceNote = `
<table align="center" cellpadding="0" cellspacing="0" width="600"  style="border-collapse: collapse;">
    <tr>
        <td>
            <img height="70" src="http://fcstoragebr.blob.core.windows.net/images/Fcamara/Logotipo-Horizontal-FCamara-2015.png">
        </td>
    </tr>
    <tr>
        <td align="center" height='100px'>
            <p style="text-align: center; padding: 3px 0; border: solid 1px #000;"><strong>DECLARAÇÃO DE PRESTAÇÃO DE SERVIÇOS</strong></p>
        </td>
    </tr>
    <tr>
        <td>
            <div class="main">

                <p>
                    Pelo presente instrumento particular e na melhor forma de direito, as partes a seguir qualificadas, de um lado {{companyname}}, regularmente inscrita no CNPJ/MF sob o nº {{companycnpj}}, com sede na {{companyaddress}}, nº {{companynumber}}, CEP. {{companycep}}, {{companycity}}/{{companystate}}, neste ato representada na forma de seu contrato social, doravante designada CONTRATADA, e, de outro lado, FCAMARA CONSULTORIA E FORMAÇÃO EM INFORMATICA LTDA, com sede na Rua Bela Cintra, nº 986, Conjunto 21 a 24, Bairro Consolação, CEP 01415-906 – São Paulo - SP, inscrita no CNPJ sob no. 03.775.758/0001-90,doravante e designada CONTRATANTE.
                </p>

                <p>
                    Objeto da Prestação de Serviços: Os serviços a serem prestados pela CONTRATADA são de Elaboração de Programas de Computador.
                </p>

                <p>
                    Qualificação e indicação dos profissionais e condições comerciais de prestação de serviços:
                </p>

                <p>
                    <table>
                        <tr>
                            <td valign=top>
                                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                            </td>
                            <td>
                                <strong>Profissional Nº 1:</strong>
                                <p>
                                    <table>
                                        <tr>
                                            <td valign=top>
                                                Perfil: &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                                            </td>
                                            <td>
                                                {{positiontype}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign=top>
                                                Início da contratação: &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                                            </td>
                                            <td>
                                                {{borrowstart}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign=top>
                                                Término da contratação: &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                                            </td>
                                            <td>
                                                {{borrowend}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign=top>
                                                Carga horária prevista: &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                                            </td>
                                            <td>
                                                {{contractmensalhour}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign=top>
                                                Valor: &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                                            </td>
                                            <td>
                                                R$ {{contractvalue}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign=top>
                                                Nome: &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                                            </td>
                                            <td>
                                                {{consultantname}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign=top>
                                                CPF: &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                                            </td>
                                            <td>
                                                {{consultantcpf}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign=top>
                                                RG: &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                                            </td>
                                            <td>
                                                {{consultantrg}}
                                            </td>
                                        </tr>
                                    </table>
                                </p>
                            </td>
                        </tr>
                    </table>
                </p>
            </div>
        </td>
    </tr>
    <tr>
        <td align="center" height='60px'>

            <p style="text-align: center; margin-top: 80px;">
                <span>
                    ___________________________________________________<br>
                    {{companyname}}<br>
                </span>
            </p>

            <p style="text-align: center; margin-top: 80px;">
                <span>
                    ___________________________________________________<br>
                    {{consultantname}}<br>
                </span>
            </p>
        </td>
    </tr>
</table>
`;

export default borrowInvoiceNote;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentTemplates/borrowedNoteDeclaration.ts